(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  'use strict';



  function buildFetchUrl(nextUrl) {
    const currentParams = new URLSearchParams(window.location.search);
    const nextPath = nextUrl.split('?')[0];
    const nextParams = new URLSearchParams(new URL(nextUrl, window.location.origin).search);
    
    // Carry all current filter/sort params forward, but use the page number from nextUrl
    currentParams.delete('page');
    for (const [key, value] of currentParams.entries()) {
      if (!nextParams.has(key)) {
        nextParams.set(key, value);
      }
    }
    
    return `${nextPath}?${nextParams.toString()}`;
  }

  let isFetching = false;
  let observer   = null;
  const grid     = document.getElementById('collection-grid');
  const statusEl = document.querySelector('.pagination-status');

  function setStatus(msg) {
    if (statusEl) {
      statusEl.textContent = msg;
      statusEl.style.display = msg ? 'block' : 'none';
    }
  }

  function extractCards(html) {
    const parser  = new DOMParser();
    const doc     = parser.parseFromString(html, 'text/html');
    const newGrid = doc.getElementById('collection-grid');
    console.log('extractCards — grid found in fetched page:', !!newGrid, '| child count:', newGrid ? newGrid.children.length : 0);
    return newGrid ? Array.from(newGrid.children) : [];
  }

  function extractNextUrl(html) {
    const parser   = new DOMParser();
    const doc      = parser.parseFromString(html, 'text/html');
    const sentinel = doc.querySelector('.pagination-sentinel');
    const url      = sentinel ? sentinel.dataset.nextUrl : null;
    console.log('extractNextUrl — next URL found:', url);
    return url;
  }

  function appendCards(cards) {
    const fragment = document.createDocumentFragment();
    cards.forEach(card => fragment.appendChild(card));
    grid.appendChild(fragment);
    console.log('appendCards — appended', cards.length, 'cards. Grid now has', grid.children.length, 'children.');
  }

  async function loadNextPage(sentinelEl) {
    if (isFetching) {
      console.log('loadNextPage — skipped, already fetching');
      return;
    }
    const nextUrl = sentinelEl.dataset.nextUrl;
    if (!nextUrl) {
      console.log('loadNextPage — no nextUrl on sentinel, stopping');
      return;
    }

    console.log('loadNextPage — fetching:', nextUrl);
    isFetching = true;
    setStatus('Loading…');
    if (observer) observer.disconnect();

    try {
      const res = await fetch(buildFetchUrl(nextUrl), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      console.log('fetch response — status:', res.status, 'ok:', res.ok);

      if (!res.ok) throw new Error('Fetch failed: ' + res.status);

      const html     = await res.text();
      console.log('fetch response — HTML length:', html.length);

      const cards    = extractCards(html);
      const nextNext = extractNextUrl(html);

      const apply = () => {
        appendCards(cards);
        sentinelEl.remove();

        if (nextNext) {
          const newSentinel = document.createElement('div');
          newSentinel.className        = 'pagination-sentinel';
          newSentinel.dataset.nextUrl  = nextNext;
          newSentinel.setAttribute('aria-hidden', 'true');
          grid.parentNode.insertBefore(newSentinel, statusEl);
          console.log('new sentinel created for:', nextNext);
          
          // Pre-fetch next page into cache immediately
          fetch(buildFetchUrl(nextNext), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          
          observeSentinel(newSentinel);
        } else {
          console.log('no more pages');
        }

        setStatus('');
        isFetching = false;
      };

      'requestIdleCallback' in window
        ? requestIdleCallback(apply, { timeout: 500 })
        : setTimeout(apply, 0);

    } catch (err) {
      console.error('loadNextPage error:', err);
      setStatus('');
      isFetching = false;
      observeSentinel(sentinelEl);
    }
  }

  function observeSentinel(sentinelEl) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          console.log('IntersectionObserver fired — isIntersecting:', entry.isIntersecting, '| sentinel nextUrl:', sentinelEl.dataset.nextUrl);
          if (entry.isIntersecting) loadNextPage(sentinelEl);
        });
      },
      { rootMargin: '1200px 0px', threshold: 0 }
    );
    observer.observe(sentinelEl);
    console.log('observeSentinel — now watching sentinel with nextUrl:', sentinelEl.dataset.nextUrl);
  }

  function init() {
    // Stop any existing observer
    if (observer) { observer.disconnect(); observer = null; }
    isFetching = false;
    
    console.log('init — grid found:', !!grid);
    if (!grid) return;

    const sentinel = document.querySelector('.pagination-sentinel');
    console.log('init — sentinel found:', !!sentinel, '| nextUrl:', sentinel ? sentinel.dataset.nextUrl : 'n/a');

    // Hide status element initially (it's empty)
    if (statusEl) statusEl.style.display = 'none';

    if (sentinel) observeSentinel(sentinel);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('collection:updated', init);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-home-slider"] && !Shopify.designMode) return;
  try {
    
class FeatureSlider extends HTMLElement {
  constructor() {
    super();
    
    this.sectionId = this.dataset.sectionId;
    this.totalSlides = parseInt(this.dataset.totalSlides);
    
    this.swiper = null;
  }

  connectedCallback() {
    // Wait for Swiper script to load (at end of body)
    if (typeof Swiper !== 'undefined') {
      this.initializeSlider();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeSlider();
      });
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  initializeSlider() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      loop: this.totalSlides > 1,
      allowTouchMove: true,
    });
  }
}

if (!customElements.get('feature-slider')) {
  customElements.define('feature-slider', FeatureSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-page-accordion"] && !Shopify.designMode) return;
  try {
    
(function() {
    function init() {
        // Accordion toggle - allow multiple open at once
        document.body.addEventListener('click', function(e) {
            if (e.target.matches('.feature-accordion-title') || e.target.closest('.feature-accordion-title')) {
                e.preventDefault();

                const accordion = e.target.closest('.feature-accordion');
                if (!accordion) return;

                accordion.classList.toggle('open');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-product-related-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.loadRecommendations();
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error('Error loading product recommendations:', e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function() {
  'use strict';

  function buildFetchUrl(nextUrl) {
    const currentParams = new URLSearchParams(window.location.search);
    const nextPath = nextUrl.split('?')[0];
    const nextParams = new URLSearchParams(new URL(nextUrl, window.location.origin).search);
    
    // Carry all current params forward, but use the page number from nextUrl
    currentParams.delete('page');
    for (const [key, value] of currentParams.entries()) {
      if (!nextParams.has(key)) {
        nextParams.set(key, value);
      }
    }
    
    return `${nextPath}?${nextParams.toString()}`;
  }

  let isFetching = false;
  let observer   = null;
  const grid     = document.querySelector('.collection-grid');
  const statusEl = document.querySelector('.pagination-status');

  function setStatus(msg) {
    if (statusEl) {
      statusEl.textContent = msg;
      statusEl.style.display = msg ? 'block' : 'none';
    }
  }

  function extractCards(html) {
    const parser  = new DOMParser();
    const doc     = parser.parseFromString(html, 'text/html');
    const newGrid = doc.querySelector('.collection-grid');
    console.log('extractCards — grid found in fetched page:', !!newGrid, '| child count:', newGrid ? newGrid.children.length : 0);
    return newGrid ? Array.from(newGrid.children) : [];
  }

  function extractNextUrl(html) {
    const parser   = new DOMParser();
    const doc      = parser.parseFromString(html, 'text/html');
    const sentinel = doc.querySelector('.pagination-sentinel');
    const url      = sentinel ? sentinel.dataset.nextUrl : null;
    console.log('extractNextUrl — next URL found:', url);
    return url;
  }

  function appendCards(cards) {
    const fragment = document.createDocumentFragment();
    cards.forEach(card => fragment.appendChild(card));
    grid.appendChild(fragment);
    console.log('appendCards — appended', cards.length, 'cards. Grid now has', grid.children.length, 'children.');
  }

  async function loadNextPage(sentinelEl) {
    if (isFetching) {
      console.log('loadNextPage — skipped, already fetching');
      return;
    }
    const nextUrl = sentinelEl.dataset.nextUrl;
    if (!nextUrl) {
      console.log('loadNextPage — no nextUrl on sentinel, stopping');
      return;
    }

    console.log('loadNextPage — fetching:', nextUrl);
    isFetching = true;
    setStatus('Loading…');
    if (observer) observer.disconnect();

    try {
      const res = await fetch(buildFetchUrl(nextUrl), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      console.log('fetch response — status:', res.status, 'ok:', res.ok);

      if (!res.ok) throw new Error('Fetch failed: ' + res.status);

      const html     = await res.text();
      console.log('fetch response — HTML length:', html.length);

      const cards    = extractCards(html);
      const nextNext = extractNextUrl(html);

      const apply = () => {
        appendCards(cards);
        sentinelEl.remove();

        if (nextNext) {
          const newSentinel = document.createElement('div');
          newSentinel.className        = 'pagination-sentinel';
          newSentinel.dataset.nextUrl  = nextNext;
          newSentinel.setAttribute('aria-hidden', 'true');
          grid.parentNode.insertBefore(newSentinel, statusEl);
          console.log('new sentinel created for:', nextNext);
          
          // Pre-fetch next page into cache immediately
          fetch(buildFetchUrl(nextNext), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          
          observeSentinel(newSentinel);
        } else {
          console.log('no more pages');
        }

        setStatus('');
        isFetching = false;
      };

      'requestIdleCallback' in window
        ? requestIdleCallback(apply, { timeout: 500 })
        : setTimeout(apply, 0);

    } catch (err) {
      console.error('loadNextPage error:', err);
      setStatus('');
      isFetching = false;
      observeSentinel(sentinelEl);
    }
  }

  function observeSentinel(sentinelEl) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          console.log('IntersectionObserver fired — isIntersecting:', entry.isIntersecting, '| sentinel nextUrl:', sentinelEl.dataset.nextUrl);
          if (entry.isIntersecting) loadNextPage(sentinelEl);
        });
      },
      { rootMargin: '1200px 0px', threshold: 0 }
    );
    observer.observe(sentinelEl);
    console.log('observeSentinel — now watching sentinel with nextUrl:', sentinelEl.dataset.nextUrl);
  }

  function init() {
    // Stop any existing observer
    if (observer) { observer.disconnect(); observer = null; }
    isFetching = false;
    
    console.log('init — grid found:', !!grid);
    if (!grid) return;

    const sentinel = document.querySelector('.pagination-sentinel');
    console.log('init — sentinel found:', !!sentinel, '| nextUrl:', sentinel ? sentinel.dataset.nextUrl : 'n/a');

    // Hide status element initially (it's empty)
    if (statusEl) statusEl.style.display = 'none';

    if (sentinel) observeSentinel(sentinel);
  }

  document.addEventListener('DOMContentLoaded', init);

})();

  } catch(e) { console.error(e); }
})();
})();
